import React, { useState } from 'react'
import GenericModal from '../generic-modal/generic-modal'
import './change-address-api-google.scss'
import GoogleApi from '../../atoms/google-api/google-api';
import GoogleApiPlaces from "../../atoms/google-api-places/google-api-places";
import Button from '../../atoms/button/button';

const ChangeAddressapigoogle = (props) => {
  const { setModalChangeAdress,addressValue, setaddressValue, addressDetailValue, setaddressDetailValue} = props;
  const [adress, setAdress] = React.useState({search: addressValue, value: addressValue});
  const [googlemaps, setGooglemaps] = React.useState();
  const [latLngCountry] = React.useState(()=> {
    switch (process.env.LOCALE) {
      case "es-EC":
        return {
          lat:  0.22985,
          lng:  101.4750519,
        }
      default:
        return {
          lat:  4.624335,
          lng:  -74.063644,
        }
    } }
    )
  const [defaulGeo, setDefaulGeo] = useState({
    center: latLngCountry,
    zoom: 13,
  });


  const [corMarket, setCorMarket] = useState({
    dragg: true,
    lat:  null,
    lng:  null
  });

  const handleChangeAdress=(adress)=>{
    setaddressValue(adress.value)
    setAdress(adress)
  }

  const handleChangeAdressDetail=(e)=>{
    setaddressDetailValue(e.target.value)
  }

  return (
    <div className="f-change-address">
      <GenericModal>
      
        <span
            className="icon2-close f-close-icon"
            onClick={() => setModalChangeAdress(null)}
        />
        <div className="f-change-address-item">
          <h2 className="f-change-address-item-title">Actualiza tu dirección</h2>
        </div>
        <div className="f-change-address-item">
            <div>
                <label>TU DIRECCIÓN{props.adult && <span> (Opcional)</span>}</label>
                <GoogleApiPlaces googleMaps={googlemaps} adress={adress} setAdress={handleChangeAdress} setDefaulGeo={setDefaulGeo} setCorMarket={setCorMarket} />
            </div>
        </div>
        <div className="f-change-address-item">
          <div>
              <label>DATOS ADICIONALES DE TU UBICACIÓN{props.adult && <span> (Opcional)</span>}</label>
              <input
                  placeholder="Barrio / edificio / apartamento"
                  type="text"
                  name="addressAdditional"
                  className="f-change-address-input-address-additional"
                  maxLength="60"
                  autoComplete="off"
                  id={"outlined-address-additional"}
                  defaultValue={addressDetailValue}
                  onChange={handleChangeAdressDetail}
              />
              <p className="f-step-register-copy">Ejemplo: Barrio El Portal, unidad portal Del Valle, Apto 1005</p>
          </div>
        </div>
        <div className="f-change-address-item">
          <GoogleApi setGooglemaps={setGooglemaps} adress={adress} setAdress={handleChangeAdress} defaulGeo={defaulGeo} setDefaulGeo={setDefaulGeo} setCorMarket={setCorMarket} corMarket={corMarket}/>
        </div>
        <div  onClick={() => setModalChangeAdress(null)}>
          <Button className="primary-pink short" title="Aceptar"/>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </GenericModal>
    </div>
  )
}

export default ChangeAddressapigoogle